import { API_AUTH, API_AUTH_FILE } from "./common";

const PrintFileApi = {
  getDieuKhoan: () => API_AUTH.get("he-thong/thoa-thuan-su-dung"),
  getThongTinKhachHangThoaThuan: (username) =>
    API_AUTH.post(`he-thong/lay-thong-tin-khach-hang-thoa-thuan?username=${encodeURIComponent(username)}`),
  xuatPDFDieuKhoan: () =>
    API_AUTH_FILE.post("he-thong/thoa-thuan-su-dung-pdf", {}, {
      responseType: "blob",
    }),
  rpOrder6XuatFilePDF: (data) =>
    API_AUTH_FILE.post("QuanLyMuaBan/PrintFile/rpOrder6XuatFilePDF", data, {
      responseType: "arraybuffer",
    }),
};

export default PrintFileApi;
